import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initializeInstallPrompt } from './pwa/installPrompt';

const root = ReactDOM.createRoot(document.getElementById('root'));

initializeInstallPrompt();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
